import { useMemo } from "react";
import { mergeClasses } from "@fluentui/react-components";
import { MILESTONE_DELIVERABLE_STATUS_TONE } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.constants";
import { dashboardTokens } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.tokens";
import {
  IDeliverablesLogTableProps,
  IReadOnlyTableColumn,
} from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.types";
import {
  getPillToneClassName,
  useGroupedWorkspaceDashboardStyles,
} from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.styles";
import { LogEmptyState } from "apps/project-iq/components/GroupedWorkspaceDashboard/LogEmptyState";
import { ReadOnlyLogTable } from "apps/project-iq/components/GroupedWorkspaceDashboard/ReadOnlyLogTable";
import { formatDate } from "apps/project-iq/utils/workspaceOverviewUtils";
import { IDeliverable } from "models/IProjectIQWorkspace";

export const DeliverablesLogTable = ({
  deliverables,
}: IDeliverablesLogTableProps): JSX.Element => {
  const styles = useGroupedWorkspaceDashboardStyles();

  const columns: IReadOnlyTableColumn<IDeliverable>[] = useMemo(
    () => [
      {
        columnKey: "name",
        header: "Name",
        renderCell: (item) => (
          <span className={styles.logPanelNameDeliverable}>{item.name}</span>
        ),
      },
      {
        columnKey: "dueDate",
        header: "Due Date",
        renderCell: (item) => (
          <span className={styles.logPanelCellMuted}>
            {item.dueDate ? formatDate(item.dueDate) : "—"}
          </span>
        ),
      },
      {
        columnKey: "status",
        header: "Status",
        renderCell: (item) => {
          const tone = MILESTONE_DELIVERABLE_STATUS_TONE[item.status];
          return (
            <span
              className={mergeClasses(
                styles.pill,
                getPillToneClassName(styles, tone?.toneKey),
              )}
            >
              {tone?.label}
            </span>
          );
        },
      },
    ],
    [styles],
  );

  return (
    <ReadOnlyLogTable<IDeliverable>
      items={deliverables}
      columns={columns}
      getRowId={(item) => item.id}
      ariaLabel="Deliverables"
      gridTemplateColumns={dashboardTokens.grid.deliverables}
      emptyState={<LogEmptyState logTab="deliverables" />}
    />
  );
};
